var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuestionForm',{attrs:{"backPath":("/questions?categoryId=" + (_vm.$route.params.categoryId)),"question":_vm.question}})}
var staticRenderFns = []

export { render, staticRenderFns }